import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API } from "@/App";
import VantaAISubscribers from "@/components/admin/VantaAISubscribers";

// Panel admin > Clients > Vanta AI : offrir Pro ou Max à un compte (comme un
// script ou un bot) et la liste des abonnés (prolonger, changer d'offre, arrêter).
// Aussi possible depuis Clients > Utilisateurs > « Donner gratuit ».

const errorText = (err, fallback) => err?.response?.data?.detail || fallback;

export default function VantaAIClients({ hdr }) {
  const [grant, setGrant] = useState({ email: "", plan: "pro", days: 30 });
  const [subsKey, setSubsKey] = useState(0);

  const submitGrant = async (e) => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/admin/vai/grant`, { ...grant, days: Number(grant.days) }, { headers: hdr() });
      toast.success(grant.plan === "free" ? `Offre retirée à ${grant.email}` : `Vanta AI ${r.data.plan.name} offert à ${grant.email}`);
      setGrant({ ...grant, email: "" });
      setSubsKey((k) => k + 1);
    } catch (err) { toast.error(errorText(err, "Impossible")); }
  };

  return (
    <div className="space-y-5" data-testid="vai-clients">
      <div>
        <h2 className="text-xl font-semibold flex items-center gap-2"><img src="/vanta-ai-mark.webp" alt="" className="w-6 h-6 rounded-md" />Clients Vanta AI</h2>
        <p className="text-sm text-white/50 mt-1">Les abonnés Pro et Max de l'IA. Une offre donnée ici est active tout de suite, sans paiement.</p>
      </div>

      <form onSubmit={submitGrant} className="rounded-xl border border-white/10 bg-white/[0.02] p-4 space-y-3">
        <p className="text-sm font-medium flex items-center gap-2"><Gift className="w-4 h-4 text-green-400" />Offrir Vanta AI</p>
        <div className="grid sm:grid-cols-[1fr_140px_110px_auto] gap-3 items-end">
          <div><Label className="text-xs">Email du compte</Label><Input type="email" required value={grant.email} onChange={(ev) => setGrant({ ...grant, email: ev.target.value })} placeholder="joueur@exemple.com" /></div>
          <div><Label className="text-xs">Offre</Label>
            <select value={grant.plan} onChange={(ev) => setGrant({ ...grant, plan: ev.target.value })} className="w-full h-10 rounded-md bg-transparent border border-white/15 px-2 text-sm">
              <option value="pro" className="bg-[#14151c]">Pro</option><option value="max" className="bg-[#14151c]">Max</option><option value="free" className="bg-[#14151c]">Gratuit (retirer)</option>
            </select>
          </div>
          <div><Label className="text-xs">Jours</Label><Input type="number" min={1} max={3650} value={grant.days} onChange={(ev) => setGrant({ ...grant, days: ev.target.value })} disabled={grant.plan === "free"} /></div>
          <Button type="submit" className="bg-green-600 hover:bg-green-700">Offrir</Button>
        </div>
      </form>

      <VantaAISubscribers hdr={hdr} reloadKey={subsKey} />
    </div>
  );
}
